import React from 'react';
import style from './CoursesSection.module.scss';

const CoursesSection = () => {
  return (
    <div id="courses" className={style.container}>
      <h1> Corsi di Formazione</h1>
      <h2>
        Non solo trattamenti: qui puoi anche formarti e diventare una professionista nel mondo lash
        & brow.
      </h2>
      <div className={style.body}>
        <h3>Corso Base Lashmaker — diventa professionista delle extension ciglia in 2–3 giorni</h3>
        <p className={style.text}>
          Vuoi iniziare una nuova professione nel mondo beauty, che unisca passione e guadagno? Il
          corso base Lashmaker è pensato per chi parte da zero e desidera iniziare a lavorare in
          modo sicuro e professionale.
        </p>
        <ul>
          Programma:
          <li>Teoria completa: anatomia delle ciglia, curvature, lunghezze e materiali</li>
          <li>Dimostrazione pratica step by step</li>
          <li>Pratica su modella sotto la supervisione dell’insegnante</li>
        </ul>
        <ul>
          Risultato:
          <li>Tecnica sicura e corretta</li>
          <li>Capacità di lavorare con il cliente dall’inizio alla fine</li>
          <li>Certificato e possibilità di iniziare subito a lavorare</li>
        </ul>
        <p>Durata: 2–3 giorni</p>
        <p>Formato: mini-gruppo o individuale</p>
        <p>Prezzo: 500 €</p>
      </div>
      <div className={style.body}>
        <h3>Corso Avanzato Lashmaker — perfeziona la tecnica</h3>
        <p className={style.text}>
          Per lashmaker già attive che vogliono migliorare velocità, pulizia ed effetto finale.
        </p>
        <ul>
          Programma:
          <li>Classico, 2D, 3D, Wet Look, Kim Effect e altri</li>
          <li>Miglioramento di simmetria e velocità</li>
          <li>Lavoro su diverse forme di occhi e ciglia</li>
          <li>Correzione errori e consigli professionali</li>
        </ul>
        <ul>
          Risultato:
          <li>Tecnica perfezionata in 2–3 giorni</li>
          <li>Aumento della qualità del servizio</li>
          <li>Possibilità di aumentare i prezzi</li>
        </ul>
        <p>Durata: 2–3 giorni</p>
        <p>Certificato di aggiornamento</p>
        <p>Prezzo: 500 €</p>
      </div>
      <div className={style.body}>
        <h3>Corso Laminazione Ciglia e Sopracciglia</h3>
        <p className={style.text}>
          Uno dei trattamenti più richiesti in Italia, ideale per principianti e professionisti.
        </p>
        <ul>
          Programma:
          <li>Teoria: struttura delle ciglia e sopracciglia, composizione dei prodotti</li>
          <li>Tecnica completa di laminazione</li>
          <li>Lavoro su forma, curvatura e direzione naturale</li>
          <li>Pratica su modella</li>
        </ul>
        <ul>
          Risultato:
          <li>Apprendimento completo in 2 giorni</li>
          <li>Tecnica sicura e risultati naturali</li>
          <li>Certificato e possibilità di lavorare subito</li>
        </ul>
        <p>Prezzo: 450 €</p>
      </div>
      <div className={style.body}>
        <h3>Corso VIP Individuale (One to One)</h3>
        <p className={style.text}>Formazione esclusiva con approccio personalizzato.</p>
        <ul>
          Adatto a:
          <li>Principianti</li>
          <li>Lashmaker esperte</li>
          <li>Chi desidera perfezionare extension o laminazione</li>
        </ul>
        <ul>
          Include:
          <li>Programma personalizzato</li>
          <li>Teoria + pratica intensiva</li>
          <li>Correzione errori e supporto post-corso</li>
          <li>Certificato</li>
        </ul>
        <p>Durata: 2–3 giorni</p>
        <p>Posti limitati, su prenotazione</p>
      </div>
      <div className={style.body}>
        <h3>Novità — Corso LED Extension Ciglia</h3>
        <p className={style.text}>Tecnologia di nuova generazione: veloce, pulita, confortevole.</p>
        <ul>
          Imparerai:
          <li>Uso corretto di colla e lampada LED</li>
          <li>Applicazione sicura senza irritazioni</li>
          <li>Maggiore durata e zero “incollaggi”</li>
          <li>Riduzione del tempo di lavoro del 30–40%</li>
        </ul>
        <ul>
          Risultato:
          <li>Lavoro più rapido ed efficace</li>
          <li>Aumento del guadagno</li>
          <li>Posizionamento come professionista di alto livello</li>
        </ul>
        <p>Teoria + pratica su modella</p>
        <p>Prezzo: 700 €</p>
      </div>
      <div className={style.body}>
        <h3>L’insegnante</h3>
        <p className={style.text}>
          <span>Dinara Valiyeva</span> — fondatrice di <span>NARA Milano Beauty Space</span>
          ,lashmaker e brow artist con oltre 15 anni di esperienza. Formata a Mosca e con trainer
          internazionali, unisce precisione tecnica e stile europeo per risultati armoniosi e
          duraturi.
        </p>
      </div>
    </div>
  );
};

export default CoursesSection;
